import { Button, Text } from '@mantine/core';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import {
	ContactDetailsWrapper,
	ContactMail,
	ContactPhone,
	HeaderContainer,
	HeaderLogo,
	LeftPart,
	RightPart,
} from '@dealstack/frontend/shared/components/Header/Header.styles';

/**
 * The unauthenticated public-signing app shell header: DealStack logo plus the
 * get-help contact details. Shared by the single-document signing page and the
 * authorised-signatory programme portal so both flows look like one product.
 */
export const PublicSigningHeader = () => {
	const tMipCreate = useTranslationMipCreate();

	return (
		<HeaderContainer>
			<LeftPart gap="1rem">
				<HeaderLogo size="sm" variant="dealstack-logo-black" />
			</LeftPart>
			<RightPart gap="0.5rem">
				<ContactDetailsWrapper gap="0.5rem">
					<Button
						component="a"
						href={`mailto:${tMipCreate('common.help_section.mail')}`}
						variant="default"
						size="md"
						leftSection={<Icon variant="help" size="lg" />}
					>
						<Text fw={400}>
							{tMipCreate('common.help_section.get_help', {
								defaultValue: 'Get Help',
							})}
						</Text>
					</Button>
					<ContactPhone>
						<Icon size="lg" variant="phone" />
						<Text variant="h6" fw={600} style={{ whiteSpace: 'nowrap' }}>
							{tMipCreate('common.help_section.phone')}
						</Text>
					</ContactPhone>
					<ContactMail
						target="_top"
						href={`mailto:${tMipCreate('common.help_section.mail')}`}
					>
						<Icon size="lg" variant="mail" />
						<Text variant="h6" fw={600} style={{ whiteSpace: 'nowrap' }}>
							{tMipCreate('common.help_section.mail')}
						</Text>
					</ContactMail>
				</ContactDetailsWrapper>
			</RightPart>
		</HeaderContainer>
	);
};
